/* eslint-disable max-len */
import type { FC } from "react";

import type { IconProps } from "./BaseIcon";
import { BaseIcon } from "./BaseIcon";

export const ReviewIcon: FC<IconProps> = (props) => {
  return (
    <BaseIcon {...props}>
      <path
        clipRule="evenodd"
        d="M26 26V28H6V26H26ZM26 6H6V28L5.7959 27.9893C4.85435 27.8938 4.1062 27.1457 4.01074 26.2041L4 26V6C4 4.89543 4.89543 4 6 4H26C27.1046 4 28 4.89543 28 6V26C28 27.0357 27.2128 27.887 26.2041 27.9893L26 28V6Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M16 8.5C16.7218 8.5 17.3877 8.88887 17.7422 9.51758L19.1963 12.0986L22.1016 12.6855C22.8092 12.8283 23.3853 13.3417 23.6084 14.0283C23.8313 14.7147 23.667 15.4677 23.1787 15.999L21.1729 18.1797L21.5137 21.124C21.5965 21.8411 21.2861 22.5473 20.7021 22.9717C20.1181 23.396 19.3508 23.4733 18.6943 23.1729L16 21.9395L13.3057 23.1729C12.6492 23.4733 11.8819 23.396 11.2979 22.9717C10.7139 22.5473 10.4035 21.8411 10.4863 21.124L10.8262 18.1797L8.82129 15.999C8.33297 15.4677 8.16874 14.7147 8.3916 14.0283C8.61469 13.3417 9.19077 12.8283 9.89844 12.6855L12.8027 12.0986L14.2578 9.51758L14.3281 9.40332C14.696 8.8423 15.3231 8.5 16 8.5ZM14.0957 13.8789L10.2939 14.6455L12.9189 17.501L12.4736 21.3545L16 19.7402L19.5264 21.3545L19.0811 17.501L21.7061 14.6455L17.9043 13.8789L16 10.5L14.0957 13.8789Z"
        fillRule="evenodd"
      />
    </BaseIcon>
  );
};
